/* I'm a JS example about how to use the theme's JS */

require('./components/browserDetection');
require('./components/navigation');
require('./components/navCollapse');
require('./components/youTubePlayer');
require('./components/faq');
require('./components/jobs-card');
require('./components/articleSlider');
require('./components/clientSlider');
require('./components/copy-to-clipboard');
require('./components/tabList');
require('./components/langswitcher');
require('./components/tracking');
require('./components/cookie-banner');
require('./components/blog-sidebar-filters');
require('./components/employer-profile');
